import { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sidebar, SidebarItem } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { LayoutDashboard, Users, ShieldCheck, UserPlus, Monitor } from 'lucide-react';

const UserManagementSideNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('user-management');

  const navItems = useMemo(
    () => [
      { path: '/users', icon: LayoutDashboard, labelKey: 'sideNav.overview', exact: true },
      { path: '/users/list', icon: Users, labelKey: 'sideNav.users' },
      { path: '/users/roles', icon: ShieldCheck, labelKey: 'sideNav.roles' },
      { path: '/users/invitations', icon: UserPlus, labelKey: 'sideNav.invitations' },
      { path: '/users/sessions', icon: Monitor, labelKey: 'sideNav.sessions' },
    ],
    []
  );

  const isActive = (item) =>
    item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path);

  return (
    <Sidebar>
      <div className="mb-2 px-3 py-1">
        <span className="text-xs font-semibold uppercase tracking-wider text-content-faint">
          {t('sideNav.sectionTitle')}
        </span>
      </div>
      {navItems.map((item) => (
        <SidebarItem
          key={item.path}
          icon={item.icon}
          label={t(item.labelKey)}
          active={isActive(item)}
          onClick={() => navigate(item.path)}
        />
      ))}
    </Sidebar>
  );
};

export default UserManagementSideNav;
